import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";

export function useComments(itemId: string | undefined) {
  return useQuery({
    queryKey: ["comments", itemId],
    queryFn: () => api.listComments(itemId!).then((r) => r.comments),
    enabled: !!itemId,
    refetchInterval: 15_000,
  });
}
